import type { PartnerDto } from "../../../api";

const CURRENCY_CODE_PATTERN = /\(([A-Z]{3})\)/;

export function getPurchaseOrderCurrency(
  partner?: PartnerDto | null,
  fallback = "QAR",
): string {
  const pricelistName = partner?.pricelist?.name ?? "";
  const match = pricelistName.match(CURRENCY_CODE_PATTERN);

  if (match?.[1]) {
    return match[1];
  }

  return fallback;
}
